<section id="testimonials">
    <h2 class="testimonial-title">What Our Customers Say</h2>

    <div class="testimonial-container container">

      <div class="testimonial-box" *ngFor="let test of testimonials">
        <div class="customer-detail">
          <div class="customer-photo">
            <img src="https://i.postimg.cc/5Nrw360Y/male-photo1.jpg" alt="" />
            <p class="customer-name">{{test.name}}</p>
          </div>
        </div>
        <div class="star-rating">
          <span class="fa fa-star checked"></span>
          <span class="fa fa-star checked"></span>
          <span class="fa fa-star checked"></span>
          <span class="fa fa-star checked"></span>
          <span class="fa fa-star checked"></span>
        </div>
        <p class="testimonial-text">
          {{test.testimonial}}
        </p>
       
      </div>

    </div>
  </section>